import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class Layout_overview extends PureComponent {
  render() {
    return (
      <div className="row" id="layout_overview">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Layout Overview</h2>
              <p>
                The JSON model controls the interface layout. The model contains
                a top-level object called “data_objects” inside of which is an
                object for each data type. The name of each data object (in
                example 1 my_data_object_1) needs to match the API name of a
                given data type. Inside each data object, there is a "settings",
                "record" and "search" object.
              </p>
              <p>
                The “settings” object controls how a data object or data type
                will be displayed in the menu and how it will appear in the
                record history panel.
              </p>
              <p>
                The record object contains an object called “default” which
                contains the default values of a new record and an object code
                “layout” which contains the interface layout when editing or
                viewing a record. The record object can also contain a “menu”
                object, which is a way of controlling the more actions menu when
                viewing a record.
              </p>
              <p>
                The last object you will find in a data type is the “search”
                object. The “search” object contains an object called “layout”
                which controls the “layout” of the objects search page.
              </p>
              <p>
                Example 1 shows a high-level structure of the interface data
                model.
              </p>

              <h3>Settings</h3>
              <table>
                <tbody>
                  <tr>
                    <td className="b top">Property</td>
                    <td className="b top">Description</td>
                  </tr>
                  <tr>
                    <td className="b">history_reminder_feilds</td>
                    <td>
                      An array of data field names from the record which will be
                      displayed in the history menu to remind the user which
                      records they have previously opened.
                    </td>
                  </tr>
                  <tr>
                    <td className="b">interface_name</td>
                    <td>
                      Interface name is the name the application will use to
                      describe this type of object.
                    </td>
                  </tr>
                  <tr>
                    <td className="b">interface_button_backcolor</td>
                    <td>
                      Background colour of buttons specific to this data object.
                    </td>
                  </tr>
                  <tr>
                    <td className="b">interface_button_forecolor</td>
                    <td>
                      Text colour of buttons specific to this data object.
                    </td>
                  </tr>
                  <tr>
                    <td className="b">interface_record_menu</td>
                    <td>
                      Menu options displayed in the edit / view record page.
                      Record menu options give you the abilty to hide, show or
                      open some components from the record menu. For more
                      details look up layout action menus.
                    </td>
                  </tr>
                  <tr>
                    <td className="b">menu_icon</td>
                    <td>
                      The menu icon that will be displayed on the homepage and
                      the left-hand side menu. icon names are taken from the
                      material icons font you can find a list of icon names in
                      this documentation.
                    </td>
                  </tr>
                  <tr>
                    <td className="b">menu_icon_color</td>
                    <td>The icon foreground colour.</td>
                  </tr>
                  <tr>
                    <td className="b">menu_icon_color_background</td>
                    <td>The icon background colour.</td>
                  </tr>
                  <tr>
                    <td className="b">menu_hide</td>
                    <td>
                      Menu hide is used to hide the icon from the main menu and
                      left hand side menu.
                    </td>
                  </tr>
                  <tr>
                    <td className="b">menu_name</td>
                    <td>
                      The name that will appear in the main menu and left hand
                      side menu.
                    </td>
                  </tr>
                  <tr>
                    <td className="b">menu_order</td>
                    <td>
                      The menu display order is based on the menu order value
                      and then alphabetical name.
                    </td>
                  </tr>
                  <tr>
                    <td className="b">shared_code</td>
                    <td>
                      String of JavaScript code fired before all code evals in
                      record and search layouts.
                    </td>
                  </tr>
                  <tr>
                    <td className="b">url</td>
                    <td>
                      URL is the name that will appear in both the API and the
                      application.
                    </td>
                  </tr>
                  <tr>
                    <td className="b">url_app_id_prefix</td>
                    <td>
                      App ID prefix is the prefix for a record number (INC-123).
                    </td>
                  </tr>
                </tbody>
              </table>
              <h3>Record Default</h3>
              <p>
                The record layout section is where all the containers, cards,
                and components are located, which make up the record display.
                This will be covered in the layout structure section of this
                documentation.
              </p>

              <h3>Record Default Smart Values</h3>
              <table>
                <tbody>
                  <tr>
                    <td className="b top">Value</td>
                    <td className="b top">Description</td>
                  </tr>
                  <tr>
                    <td className="b">[[ME]]</td>
                    <td>
                      Returns an object with the current users first name last
                      name and user ID.
                    </td>
                  </tr>
                  <tr>
                    <td className="b">[[NOW]]</td>
                    <td>Current Datetime in Zulu format.</td>
                  </tr>
                  <tr>
                    <td className="b">[[RND32]]</td>
                    <td>Randomly generated 32 character string.</td>
                  </tr>
                  <tr>
                    <td className="b">[[RND48]]</td>
                    <td>Randomly generated 48 character string.</td>
                  </tr>
                  <tr>
                    <td className="b">[[RND64]]</td>
                    <td>Randomly generated 64 character string.</td>
                  </tr>
                </tbody>
              </table>
              <h3>Menus</h3>
              <p>
                The record menu object is a way of manipulating the menu on the
                display record page. This menu only works in relation to certain
                components and will be covered under the Layout Action Menus
                section of this documentation.
              </p>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>Layout Overview Example</h2>
            </section>
            <section>
              <h3>Example 1: Layout data object structure</h3>
              <div className="darkCode">
                <div>Level 1:</div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"data_objects"</span>: &#123;
                </div>
                <div className="i2">
                  <span className="jsonG">
                    "<strong>my_data_object_1</strong>"
                  </span>
                  : &#123;
                </div>
                <div className="i3">
                  <span className="jsonG">"settings"</span>: &#123;
                </div>
                <div className="i4">
                  <span className="jsonG">"history_reminder_feilds"</span>: [{" "}
                  <span className="jsonY">"text_name"</span> ],
                </div>
                <div className="i4">
                  <span className="jsonG">"interface_name"</span>:{" "}
                  <span className="jsonY">"Incident"</span>,
                </div>
                <div className="i4">
                  <span className="jsonG">"interface_button_backcolor"</span>:{" "}
                  <span className="jsonY">"#1E88E5"</span>,
                </div>
                <div className="i4">
                  <span className="jsonG">"interface_button_forecolor"</span>:{" "}
                  <span className="jsonY">"#ffffff"</span>,
                </div>
                <div className="i4">
                  <span className="jsonG">"interface_record_menu"</span>: &#123;
                  ... &#125;,
                </div>
                <div className="i4">
                  <span className="jsonG">"menu_icon"</span>:{" "}
                  <span className="jsonY">"headset_mic"</span>,
                </div>
                <div className="i4">
                  <span className="jsonG">"menu_icon_color"</span>:{" "}
                  <span className="jsonY">"#FFD54F"</span>,
                </div>
                <div className="i4">
                  <span className="jsonG">"menu_icon_color_background"</span>:{" "}
                  <span className="jsonY">"#1976d2"</span>,
                </div>
                <div className="i4">
                  <span className="jsonG">"menu_hide"</span>:{" "}
                  <span className="jsonP">false</span>,
                </div>
                <div className="i4">
                  <span className="jsonG">"menu_name"</span>:{" "}
                  <span className="jsonY">"Incident Manager"</span>,
                </div>
                <div className="i4">
                  <span className="jsonG">"menu_order"</span>:{" "}
                  <span className="jsonP">1</span>,
                </div>
                <div className="i4">
                  <span className="jsonG">"shared_code"</span>:{" "}
                  <span className="jsonY">
                    "{"function test() { console.log('test fired!'); }"}"
                  </span>
                  ,
                </div>
                <div className="i4">
                  <span className="jsonG">"url"</span>:{" "}
                  <span className="jsonY">"incident"</span>,
                </div>
                <div className="i4">
                  <span className="jsonG">"url_app_id_prefix"</span>:{" "}
                  <span className="jsonY">"INC"</span>
                </div>
                <div className="i3">&#125;,</div>
                <div className="i3">
                  <span className="jsonG">"record"</span>: &#123;
                </div>
                <div className="i4">
                  <span className="jsonG">"default"</span>: &#123;
                </div>
                <div className="i5">
                  <span className="jsonG">"text_name"</span>:{" "}
                  <span className="jsonY">"New Incident"</span>
                </div>
                <div className="i4">&#125;,</div>
                <div className="i4">
                  <span className="jsonG">"create_options"</span>: &#123; ... &#125;,
                </div>
                <div className="i4">
                  <span className="jsonG">"menu"</span>: &#123; ... &#125;,
                </div>
                <div className="i4">
                  <span className="jsonG">"layout"</span>: &#123; ... &#125;
                </div>
                <div className="i3">&#125;,</div>
                <div className="i3">
                  <span className="jsonG">"search"</span>: &#123;
                </div>
                <div className="i4">
                  <span className="jsonG">"layout"</span>: &#123; ... &#125;
                </div>
                <div className="i3">&#125;</div>
                <div className="i2">&#125;,</div>
                <div className="i2">
                  <span className="jsonG">
                    "<strong>my_data_object_2</strong>"
                  </span>
                  : &#123; ... &#125;
                </div>
                <div className="i1">&#125;</div>
                <div>&#125;</div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default Layout_overview;



// WEBPACK FOOTER //
// ./src/components/knowlege/interface/Layout_overview.js